<script>
  import { onMount } from "svelte"
  import SimpleBar from "@woden/svelte-simplebar"

  let country = null
  let error = null
  let search_results = []
  const countries = [
    {
      class: "ie",
      name: "Ireland",
      url: "https://slf24.ie",
    },
    {
      class: "gb",
      name: "United Kingdom",
      url: "https://slf24.co.uk",
    },
    {
      class: "pl",
      name: "Poland",
      url: "https://slf24.pl",
    },
    {
      class: "de",
      name: "Germany",
      url: "https://slf24.de",
    },
    {
      class: "at",
      name: "Austria",
      url: "https://slf24.at",
    },
    {
      class: "fr",
      name: "France",
      url: "https://slf24.fr",
    },
    {
      class: "cz",
      name: "Czech Republic",
      url: "https://slf24.com/cz/",
    },
  ]

  countries.sort(function (a, b) {
    return a.name.localeCompare(b.name)
  })

  const getCountry = (code) => {
    let temp = false
    countries.forEach((country) => {
      if (country.class == code.toLowerCase()) {
        temp = country
      }
    })
    return temp
  }

  const seeAll = () => {
    search_results = countries
  }

  const findCountry = (value) => {
    let temp = []
    if (value) {
      countries.forEach((country) => {
        if (country.name.toUpperCase().includes(value.toUpperCase())) {
          temp.push(country)
        }
      })
    }
    search_results = temp
  }

  onMount(async () => {
    fetch("https://ipapi.co/json/", {
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(function (response) {
        if (response.status !== 200) {
          error =
            "There was a problem with determining your current location. Please check your browser settings."
        }

        // Examine the text in the response
        response.json().then(function (data) {
          const response = getCountry(data.country_code)
          if (response) {
            country = response
          } else {
            if (data.country_name) {
              country = {
                name: data.country_name,
              }
            } else {
              let regionNames = new Intl.DisplayNames(["en"], {
                type: "region",
              })
              const countryName = regionNames.of(data.country_code)
              country = {
                name: countryName,
              }
            }
          }
        })
      })
      .catch(function (err) {
        error =
          "There was a problem with determining your current location. Please check your browser settings."
      })
  })
</script>

<p class="location-popup_message">
  {#if error}
    <div class="location-error">
      {@html error}
    </div>
  {:else if country}
    Seems like you are from {@html country.name},<br />
    {#if country.url}
      would you like us to redirect you to SLF24
      {@html country.name}?
    {:else}
      but we are not available in that country.<br />
      Check the full list of our online shops below.
    {/if}
  {:else}
    <div class="loading" />
  {/if}
</p>

<div class="location-popup_country">
  {#if country && country.url}
    <a href={country.url} class={`country item-${country.class}`}
      >Go to {@html country.name}</a
    >
  {/if}
  <div class="input-wrapper search">
    <input
      type="text"
      id="search-input"
      placeholder="Find other country"
      on:keyup={(e) => findCountry(e.target.value)}
    />
  </div>
  {#if search_results.length === 0}
    <div class="button see-all" on:click={seeAll}>See all countries</div>
  {/if}
  <SimpleBar
    class={`search-results ${search_results.length === 0 ? "empty" : ""}`}
  >
    {#if search_results.length > 0}
      {#each search_results as result}
        <a href={result.url} class={`country item-${result.class}`}
          >{result.name}</a
        >
      {/each}
    {/if}
  </SimpleBar>
</div>

<style lang="sass">
	@import './Location.sass'
</style>
